import { IComponentController } from 'angular';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMenu } from '../../../../../core/services/menu/menu.service';
import { IMonoOccurrence, IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IMenuItemActionClass } from '../../../../../core/services/menu/menu-item-action.service';
import { IMenuItemActionTelechargementClass } from '../../../../../core/services/menu/menu-item-action-telechargement.service';

interface IPageRe0042 extends IComponentController {
    menuBandeau: IMenu;
    monoOccurrence: IMonoOccurrence;
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    rsiMultiOccurrenceOptions: IMultiOccurrenceOptions;
    rsiMultiOccurrence: IMultiOccurrence;
    rstMultiOccurrenceOptions: IMultiOccurrenceOptions;
    rstMultiOccurrence: IMultiOccurrence;
    rdbMultiOccurrenceOptions: IMultiOccurrenceOptions;
    rdbMultiOccurrence: IMultiOccurrence;
    rdrMultiOccurrenceOptions: IMultiOccurrenceOptions;
    rdrMultiOccurrence: IMultiOccurrence;
    rsbMultiOccurrenceOptions: IMultiOccurrenceOptions;
    rsbMultiOccurrence: IMultiOccurrence;
    rieMultiOccurrenceOptions: IMultiOccurrenceOptions;
    rieMultiOccurrence: IMultiOccurrence;
}

/* @ngInject */
export default function Re0042Controller(
    Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    MenuItemAction: IMenuItemActionClass,
    MenuItemActionTelechargement: IMenuItemActionTelechargementClass
) {
    const vm: IPageRe0042 = this;

    vm.$onInit = $onInit;

    function $onInit() {
        vm.monoOccurrenceOptions = {
            formulaire: new Formulaire('LBL_BLC_ID', [])
        };

        vm.menusMod = [
            new MenuItemAction(
                'MOD',
                'BOUMOD',
                (data: any) => ({
                    rslflgmod: data.rslflgmod
                }),
                {
                    icon: 'edit',
                    iconButton: true,
                    successAction: () => {
                        vm.monoOccurrence.fetchData();
                    }
                }
            )
        ];

        vm.menusExc = [
            new MenuItemAction(
                'EXC',
                'BOUEXC',
                (data: any) => ({
                    rslflgexc: data.rslflgexc
                }),
                {
                    icon: 'edit',
                    iconButton: true,
                    successAction: () => {
                        vm.monoOccurrence.fetchData();
                    }
                }
            )
        ];

        vm.btnMenus = {
            flgrwb: [
                new MenuItemActionTelechargement(
                    'LBL_TELECHARGER',
                    'BOUPDF',
                    (data: any) => ({
                        rslcleint: data.$id
                    }),
                    {
                        iconButton: true,
                        icon: 'attach_file'
                    }
                ),
                new MenuItemAction(
                    '',
                    'BOUDELRWB',
                    (data: any) => ({
                        rslcleint: data.$id
                    }),
                    {
                        messageConfirmation: 'BOUCONFIRM',
                        iconButton: true,
                        icon: 'delete'
                    }
                )
            ]
        };

        vm.rsiMultiOccurrenceOptions = {
            fonctions: {
                importation: true
            },
            colonnesFixesGauche: [{ nom: 'tagcod', largeur: 84 }],
            colonnesVisibles: [
                { nom: 'tagdscabr', largeur: 210 },
                { nom: 'imp', largeur: 310 },
                { nom: 'msgerrimp', largeur: 262 },
                { nom: 'impini', largeur: 310 },
                { nom: 'aftcod', largeur: 105 },
                { nom: 'posnumdoc', largeur: 105 },
                { nom: 'lemcod', largeur: 117 },
                { nom: 'temcod', largeur: 120 },
                { nom: 'unocod', largeur: 100 },
                { nom: 'dernumdoc', largeur: 126 },
                { nom: 'drpnumdoc', largeur: 115 }
            ],
            colonnesFixesDroite: [
                { nom: 'rsimntcal', largeur: 126 },
                { nom: 'flgerr', largeur: 100 }
            ],
            formulaire: new Formulaire([new FormulaireItem('imp', { largeur: 50 }), new FormulaireItem('rsimntcal', { largeur: 50 })])
        };

        vm.rstMultiOccurrenceOptions = {
            colonnesFixesGauche: [
                { nom: 'ppacod', largeur: 84 },
                { nom: 'tagcod', largeur: 90 }
            ],
            colonnesVisibles: [
                { nom: 'tagdscabr', largeur: 210 },
                { nom: 'aftcod', largeur: 105 },
                { nom: 'posnumdoc', largeur: 105 },
                { nom: 'lemcod', largeur: 117 },
                { nom: 'temcod', largeur: 120 },
                { nom: 'unocod', largeur: 100 },
                { nom: 'dernumdoc', largeur: 126 },
                { nom: 'drpnumdoc', largeur: 115 },
                { nom: 'urgcod', largeur: 90 },
                { nom: 'urgdscabr', largeur: 280 },
                { nom: 'strcod', largeur: 90 },
                { nom: 'strdsc', largeur: 280 },
                { nom: 'geccodanc', largeur: 125 },
                { nom: 'gecdscanc', largeur: 280 },
                { nom: 'eeccodanc', largeur: 130 },
                { nom: 'rstsalanc', largeur: 115 },
                { nom: 'gecodnou', largeur: 137 },
                { nom: 'gecdscnou', largeur: 280 },
                { nom: 'eeccodnou', largeur: 145 },
                { nom: 'rstsalnou', largeur: 115 },
                { nom: 'vaersttyplig_dsc', largeur: 147 },
                { nom: 'tagcodret', largeur: 124 },
                { nom: 'tagdscabrret', largeur: 280 }
            ],
            colonnesFixesDroite: [
                { nom: 'rstqtecal', largeur: 126 },
                { nom: 'rstmntcal', largeur: 126 },
                { nom: 'rstflgexc', largeur: 100 }
            ]
        };

        vm.rsbMultiOccurrenceOptions = {
            colonnesVisibles: [
                { nom: 'ppacod', largeur: 84 },
                { nom: 'rsbdatsal', largeur: 100 },
                { nom: 'aftcod', largeur: 105 },
                { nom: 'rcecod', largeur: 90 },
                { nom: 'rcedscabr', largeur: 280 },
                { nom: 'rsbsalbasanc', largeur: 126 },
                { nom: 'rsbsalbasnou', largeur: 135 }
            ]
        };

        vm.rieMultiOccurrenceOptions = {
            colonnesVisibles: [
                { nom: 'ppacod', largeur: 84 },
                { nom: 'rietauhoranc', largeur: 133 },
                { nom: 'rietauhornou', largeur: 133 }
            ]
        };

        vm.rdbMultiOccurrenceOptions = {
            colonnesFixesGauche: [
                { nom: 'ppacod', largeur: 84 },
                { nom: 'bqecod', largeur: 84 }
            ],
            colonnesVisibles: [
                { nom: 'bqedscabr', largeur: 280 },
                { nom: 'dbscod1', largeur: 110 },
                { nom: 'dbscod2', largeur: 110 },
                { nom: 'vaesystrsbqe_dsc', largeur: 120 }
            ],
            colonnesFixesDroite: [
                { nom: 'rdbqte', largeur: 140 },
                { nom: 'flgexc', largeur: 100 }
            ]
        };

        vm.rdrMultiOccurrenceOptions = {
            colonnesFixesGauche: [
                { nom: 'ppacod', largeur: 84 },
                { nom: 'rcecod', largeur: 90 }
            ],
            colonnesVisibles: [
                { nom: 'rcedscabr', largeur: 280 },
                { nom: 'rdrmntemp', largeur: 137 },
                { nom: 'rdrmntemr', largeur: 137 },
                { nom: 'rdrmntadm', largeur: 137 },
                { nom: 'rdrqteadm', largeur: 137 },
                { nom: 'cotcod', largeur: 133 },
                { nom: 'cotdsc', largeur: 280 },
                { nom: 'cdfcod', largeur: 115 },
                { nom: 'vaedsccdf', largeur: 184 },
                { nom: 'rdrflgbloprd', largeur: 100 },
                { nom: 'tagcod', largeur: 127 },
                { nom: 'tagdscabr', largeur: 280 },
                { nom: 'rdrmntseu', largeur: 139 },
                { nom: 'rdrmntadmemp', largeur: 155 },
                { nom: 'rdrmntadmemr', largeur: 166 },
                { nom: 'rdricvcod', largeur: 138 },
                { nom: 'rdricvdsc', largeur: 280 }
            ]
        };
    }
}
